<template>
  <div ref="chart" :style="chartStyle"></div>
</template>

<script>
// Lightweight Vue 2 wrapper around the official Google Charts loader.
// (vue-google-charts@1 targets Vue 3 and can't be used in this Vue 2 app.)
let loaderPromise = null;
function loadGoogleCharts() {
  if (loaderPromise) return loaderPromise;
  loaderPromise = new Promise((resolve, reject) => {
    const start = () => {
      window.google.charts.load("current", { packages: ["corechart"] });
      window.google.charts.setOnLoadCallback(resolve);
    };
    if (window.google && window.google.charts) return start();
    const script = document.createElement("script");
    script.src = "https://www.gstatic.com/charts/loader.js";
    script.async = true;
    script.onload = start;
    script.onerror = reject;
    document.head.appendChild(script);
  });
  return loaderPromise;
}

export default {
  name: "GoogleChart",
  props: {
    type: { type: String, required: true }, // PieChart, ColumnChart, BarChart, ComboChart, ...
    data: { type: Array, default: () => [] },
    options: { type: Object, default: () => ({}) },
    height: { type: [String, Number], default: 240 },
  },
  data() {
    return { chart: null };
  },
  computed: {
    chartStyle() {
      const h =
        typeof this.height === "number" ? this.height + "px" : this.height;
      return { width: "100%", height: h };
    },
  },
  watch: {
    data: { handler: "draw", deep: true },
    options: { handler: "draw", deep: true },
  },
  methods: {
    async draw() {
      if (!this.data || this.data.length < 1) return;
      try {
        await loadGoogleCharts();
      } catch (e) {
        // Loader blocked (offline / CSP) — fail quietly, no chart.
        return;
      }
      const g = window.google;
      if (!g || !g.visualization || !this.$refs.chart) return;
      const Ctor = g.visualization[this.type];
      if (!Ctor) return;
      const dt = g.visualization.arrayToDataTable(this.data);
      if (!this.chart) this.chart = new Ctor(this.$refs.chart);
      this.chart.draw(dt, this.options);
    },
    onResize() {
      clearTimeout(this._rt);
      this._rt = setTimeout(() => this.draw(), 200);
    },
  },
  mounted() {
    this.draw();
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
    clearTimeout(this._rt);
  },
};
</script>
